module.exports = __webpack_public_path__ + "static/media/inflicted.2d55e753.mp3";